import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const fetchTeacherProfile = createAsyncThunk(
  "teacher/fetchProfile",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get("/teacher/profile");
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch profile"
      );
    }
  }
);

export const updateTeacherProfile = createAsyncThunk(
  "teacher/updateProfile",
  async (formData, { rejectWithValue }) => {
    try {
      const data = new FormData();

      for (const key in formData) {
        if (formData[key] instanceof File) {
          data.append(key, formData[key]);
        } else if (Array.isArray(formData[key])) {
          data.append(key, JSON.stringify(formData[key]));
        } else {
          data.append(key, formData[key] ?? "");
        }
      }
      if ("offers_trial" in formData) {
        data.set("offers_trial", formData.offers_trial ? "true" : "false");
      }
      const response = await axiosInstance.patch(
        "/teacher/update-profile",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Update failed");
    }
  }
);
